import { $repositories } from '~/plugins/repositories'

const state = () => ({
  userInfo: null,
  jwtToken: null,
  isTeacher: false,
  isMentor: false
})

const mutations = {
  set(state, { type, payload }) {
    state[type] = payload
  }
}

const getters = {
  getUserInfo(state) {
    return state.userInfo
  }
}

const actions = {
  async getUserData({ commit }) {
    try {
      const { data } = await $repositories.users.getUserInfo()
      commit('set', { type: 'userInfo', payload: data })
    } catch (e) {}
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
